import { createReducer, on } from '@ngrx/store';
import { ApplicationConfigurationApiActions } from './application-configuration.actions';
import { adapter, initialState } from './application-configuration.state';

export const applicationConfigurationFeatureKey = 'applicationConfiguration';

export const applicationConfigurationReducer = createReducer(
  initialState,
  on(ApplicationConfigurationApiActions.configurationLoaded, (state, { configurations }) =>
    adapter.upsertMany(configurations, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectApplicationConfigurationIds = selectIds;

export const selectApplicationConfigurationEntities = selectEntities;

export const selectAllApplicationConfigurations = selectAll;
